<template>
    <HeadingContainer :addPaddingBottom="false" heading="Inbox">
        <HugeSpinner v-if="loadingThreads"/>
        <div v-else class="row pv3 pv4-ns">
            
            <div class="col-xs-12 col-sm-8 col-md-5 col-lg-4 mb5">
                <ContactsCard @selectedContactChanged="selectedContactChanged" />
            </div>

            <div v-if="!smallOrLess" class="col-xs-12 col-md-7 col-lg-8">
                <MessagesCard />
            </div>

        </div>
    </HeadingContainer>
</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import ContactsCard from '@/components/inbox/contactsCard/ContactsCard.vue';
import MessagesCard from '@/components/inbox/messagesCard/MessagesCard.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        HeadingContainer,
        ContactsCard,
        MessagesCard,
        HugeSpinner
    },
    computed: {
        ...mapState('messages', ['loadingThreads', 'threads']),
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    },
    methods: {
        ...mapActions('messages', ['getThreads', 'getMessages']),
        getContactId(contactIndex) {
            return this.threads[contactIndex].id;
        },
        selectedContactChanged(contactIndex) {
            if (!this.smallOrLess) {
                this.getMessages(this.getContactId(contactIndex));
            }
        }
    },
    created: function() {
        this.getThreads().then(() => {
            if (this.threads.length > 0) {
                this.selectedContactChanged(0);
            }
        });
    }
};
</script>
